import { render, staticRenderFns } from "./DomainData.vue?vue&type=template&id=34b65660&"
import script from "./DomainData.vue?vue&type=script&lang=js&"
export * from "./DomainData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports